<template>
  <el-drawer
    v-model="layerFlag"
    :close-on-click-modal="true"
    direction="rtl"
    :destroy-on-close="true"
    :before-close="handleClose"
    size="50%">
    <template #title>
      <div class="drawer-title">Secret</div>
    </template>
    <template #default>
      <div class="sk">
        {{ sk }}
      </div>
      <div class="copy-wrap">
        <div class="copy">
          <svg-icon icon-class="copy" />
          <span @click="copyFun(sk)">{{ $t('copy') }}</span>
        </div>
      </div>
    </template>
    <template #footer>
      <div>
        <el-button @click="handleClose">
          {{ $t('form.cancel') }}
        </el-button>
        <el-button type="primary" @click="handleClose">
          {{ $t('form.submit') }}
        </el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import { getSecret } from '@/api/users/aksk'
import { computed, ref, watch } from 'vue'
import copy from '@/composables/copy'
export default {
  props: {
    layer: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  emits: ['getList', 'update:layer'],
  setup(props, { emit }) {
    const layerFlag = computed({
      get: () => props.layer,
      set: (value) => emit('update:layer', value)
    })
    const handleClose = () => {
      layerFlag.value = !layerFlag.value
    }
    const sk = ref('')
    const getAk = async() => {
      const res = await getSecret({ ak: props.row.ak, aksk_id: props.row.id })
      sk.value = res.data.sk
    }
    // 监听弹层显示与否
    watch(layerFlag, (nv, ov) => {
      if (nv) {
        getAk()
      }
    })
    return {
      layerFlag,
      sk,
      handleClose
    }
  },
  methods: {
    copyFun(val) {
      copy(val)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.sk {
  font-size: 14px;
  color: $grey-8;
}
</style>
